import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixSwitch from '@radix-ui/react-switch';
import clsx from 'clsx';
import React from 'react';
/**
 * A controlled switch component atom.
 */
const Switch = React.forwardRef((props, ref) => {
    return (_jsx(RadixSwitch.Root, { ref: ref, ...props, className: clsx('transition-bg radix-state-checked:bg-violet-60 h-[18px] w-8 rounded-full bg-gray-300'), children: _jsx(RadixSwitch.Thumb, { className: clsx('radix-state-checked:translate-x-[19px] block h-2 w-2 translate-x-[5px] rounded-full bg-white transition-transform') }) }));
});
Switch.displayName = 'Switch';
export default Switch;
//# sourceMappingURL=index.js.map